import { AppModel } from "../types/AppModel";

export const GamesInDevelopment: AppModel[] = [{
  name: "Lien Xi",
  image: process.env.PUBLIC_URL + 'Assets/LianXi.png',
  description: "Lien Xi is a stunning VR adventure game where you play as a young adventurer from a desert village as he leaves home searching for greatness beyond the dunes. Seek out legendary weapons and cast spells by drawing symbols in the air, as you explore a vast island on a quest to find something more interesting than sand.",
  upVotes: 0,
  downVotes: 0,
  docsLink: ""
}]